export default function getBaseUrl() {
  if (window.location?.hostname === "localhost") {
    return { subDomain: "litigation", baseUrl: "https://api.themedius.ai" };
  }

  const host = window.location.host;
  const hostSplitArr = host.split(".");

  if (hostSplitArr[0] === "dev") {
    return { subDomain: "litigation", baseUrl: "https://dev.api.themedius.ai" };
  }

  return { subDomain: "litigation", baseUrl: "https://api.themedius.ai" };
}
